// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2TtGm","box":"WorkspacesBox_box__1__FQ","node":"WorkspacesBox_node__2tdzl"};